import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, mapTo, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import {
  RespLogout,
  RespSignin,
  RespSignup,
  Tokens,
} from "../model/auth.model";
import jwt_decode from "jwt-decode";
import { Router } from "@angular/router";
@Injectable({
  providedIn: "root",
})
export class AuthService {
  private readonly JWT_TOKEN = "JWT_TOKEN";
  private readonly REFRESH_TOKEN = "REFRESH_TOKEN";
  private readonly USERNAME = "USERNAME";

  private readonly ROLE = "ROLE";
  private readonly USER_ID = "USER_ID";

  // private loggedUser!: string;
  private baseUrl = environment.baseUrl;
  constructor(private httpClient: HttpClient, private router: Router) { }

  public signup(user: {
    username: string | null;
    password: string | null;
    email: string | null;
    first_name: string | null;
    last_name: string | null;
  }): Observable<RespSignup> {
    return this.httpClient.post<RespSignup>(`${this.baseUrl}auth/signup`, user);
  }

  public signin(user: {
    username: string | null;
    password: string | null;
  }): Observable<RespSignin> {
    return this.httpClient
      .post<RespSignin>(`${this.baseUrl}auth/signin`, user)
      .pipe(
        tap((_response: RespSignin) => {
          this.doLoginUser(user.username, _response.data);
        })
      );
  }

  public logout(): Observable<RespLogout> {
    return this.httpClient
      .post<RespLogout>(`${this.baseUrl}auth/logout`, {
        refreshToken: this.getRefreshToken(),
      })
      .pipe(
        tap((_response: RespLogout) => {
          this.doLogoutUser();
        }),
      );
  }

  public refreshToken() {
    return this.httpClient
      .post<any>(`${this.baseUrl}auth/refresh`, {
        refreshToken: this.getRefreshToken(),
      })
      .pipe(
        tap((_response: any) => {
          this.storeJwtToken(_response.data.jwt);
        }),
        catchError((error) => {
          this.doLogoutUser();
          this.router.navigate(["/sign-in"]);
          return throwError(() => error);
        })
      );
  }

  private doLoginUser(username: string | null, tokens: Tokens) {
    this.storeUsername(username);
    this.storeJwtToken(tokens.jwt);
    this.storeRefreshToken(tokens.refreshToken);
  }

  private storeRefreshToken(refreshToken: string) {
    localStorage.setItem(this.REFRESH_TOKEN, refreshToken);
  }
  private storeJwtToken(jwt: string) {
    localStorage.setItem(this.JWT_TOKEN, jwt);

    const _resptest: any = jwt_decode(jwt);
    const roles: string = _resptest.roles;
    const user_id: number = _resptest.user_id;
    localStorage.setItem(this.ROLE, roles);
    localStorage.setItem(this.USER_ID, user_id.toString());
  }
  private storeUsername(username: string | null) {
    if (username) {
      localStorage.setItem(this.USERNAME, username);
    }
  }
  private doLogoutUser() {
    this.removeTokens();
  }
  public isLoggedIn() {
    return !!this.getJwtToken();
  }
  public getJwtToken() {
    return localStorage.getItem(this.JWT_TOKEN);
  }

  private getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN);
  }
  public getUsername() {
    return localStorage.getItem(this.USERNAME);
  }
  public getUserId() {
    return localStorage.getItem(this.USER_ID);
  }
  public getRole() {
    return localStorage.getItem(this.ROLE);
  }

  public isRole(role: string) {
    const roles_text = localStorage.getItem(this.ROLE);
    if (roles_text && roles_text!.length > 0) {
      const roles_list = roles_text!.split(',');
      return roles_list.indexOf(role) == -1 ? false : true;
    }
  }

  private removeTokens() {
    localStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.REFRESH_TOKEN);
    localStorage.removeItem(this.USERNAME);
    localStorage.removeItem(this.ROLE);
    localStorage.removeItem(this.USER_ID);
  }

  public sendMail(_var: {
    name: string | null;
    email: string | null;
    subject: string | null;
    message: string;
  }): Observable<any> {
    const _route = "email";

    // const _name = _var.name ? "&name=" + _var.name : "";
    // const _email = _var.email ? "&name=" + _var.email : "";
    // const _subject = _var.subject ? "&name=" + _var.subject : "";
    // const _message = _var.message ? "&name=" + _var.message : "";
    // const _url = `${this.baseUrl}${_route}`;

    return this.httpClient.post<any>(`${this.baseUrl}${_route}`, _var);
  }
}
